import type { QueryClient } from '@tanstack/react-query';
import { createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import { SEARCH_CONFIG } from '@pc/lib/search';
import { RouteFailure } from './components/RouteFailure';

/** Router construction, kept out of main.tsx so it can be built without mounting the app. */
export function buildRouter(queryClient: QueryClient) {
  return createRouter({
    routeTree,
    context: { queryClient },
    defaultPreload: 'intent',
    // Every route gets this without opting in — see `components/RouteFailure.tsx`
    // for why one thrown render used to take the whole console down with it.
    defaultErrorComponent: RouteFailure,
    ...SEARCH_CONFIG,
  });
}

export type AppRouter = ReturnType<typeof buildRouter>;
